module.exports = __webpack_public_path__ + "static/media/12x102.178bed8d.png";